<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.questions', 2),
                        href: meta.links.questions_index,
                    },
                    {
                        name: $t('messages.import'),
                        href: null,
                    },
                    {
                        name: subject.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <AlertMessage class="mt-5 inline-block" type="info">
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <template v-slot:body>
                    <AppButton :href="meta.links.template_url" target="_blank">{{ $t('messages.template') }}</AppButton>
                </template>
            </AlertMessage>
        </div>

        <form :action="meta.links.store" method="post" @submit.prevent="submit" class="mt-5">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.title')" for="title" />
                            <FormInput
                                id="title"
                                v-model="form.title"
                                type="text"
                                name="title"
                                :placeholder="$t('messages.(optional)')"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.title" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <FormLabel :value="$tc('messages.grade_levels', 2)" for="grade_level_ids" />
                        <div class="mt-1 flex gap-2">
                            <label v-for="grade_level in options.grade_levels" class="mr-1" :key="grade_level.value">
                                <input
                                    v-model="form.grade_level_ids"
                                    name="grade_levels"
                                    :value="grade_level.value"
                                    type="checkbox"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                />
                                {{ grade_level.text }}
                            </label>
                        </div>
                        <FormError :value="form.errors.grade_level_ids" class="mt-2" />
                    </div>

                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.files', 1)" for="file" />
                            <input
                                id="file"
                                @input="form.file = $event.target.files[0]"
                                name="file"
                                type="file"
                                accept=".csv"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.file" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>

        <div class="flex justify-end mt-5">
            <AlertMessage class="mt-5 inline-block" type="alert">
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <template v-slot:body>
                    {{ $t('messages.is_reusable_should_be_marked_explanation') }}
                </template>
            </AlertMessage>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '../../Activities/Subactivities/SubmitFormButton.vue';
import AlertMessage from '../../../../components/AlertMessage.vue';
import AppButton from '../../../../components/AppButton.vue';
import FormInput from '../../../../components/Forms/FormInput.vue';

export default {
    components: {
        FormInput,
        AppButton,
        AlertMessage,
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormLabel,
        FormError,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options', 'subject'],
    data() {
        return {
            form: this.$inertia.form({
                title: '',
                grade_level_ids: [],
                file: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store, {});
        },
    },
};
</script>
